import clsx from 'clsx';

import { ModalBaseStylesNames } from '@mantine/core';

import classes from './Modal.module.css';

export const ModalOverrideClassNames: (props: {
  showHeaderUnderline?: boolean;
  noContentPadding?: boolean;
  bottomSheet?: boolean;
}) => Partial<Record<ModalBaseStylesNames, string>> = (props) => {
  return {
    root: classes.root,
    content: clsx(classes.content, {
      [classes.bottomSheetContent]: props.bottomSheet
    }),
    overlay: classes.overlay,
    inner: clsx(classes.inner, {
      [classes.bottomSheetInner]: props.bottomSheet
    }),
    header: clsx(classes.header, {
      [classes.headerWithUnderline]: props.showHeaderUnderline
    }),
    title: classes.title,
    body: clsx(classes.body, {
      [classes.bodyNoContentPadding]: props.noContentPadding
    })
  };
};

export const FooterClasses = (props: { footerBorder?: boolean }) => {
  return clsx(classes.footer, {
    [classes.footerWithBorder]: props.footerBorder
  });
};
